// import { inject } from '@angular/core';
// import { firstValueFrom } from 'rxjs';
// import { ProductService } from '../product.service';
import { preloadedProductsTopBrands } from '../../data-preloaded/products-top-brands-data';
import { TopMarca } from '../../types/product.types';

// RESOLVERS PARA PRODUCTOS

/**
 * Resolver para obtener marcas de productos (top marcas)
 * @param route - Información de la ruta actual
 * @returns Promise con la respuesta de marcas de productos (top marcas)
 */
export const productsTopBrandsResolver = async (): Promise<TopMarca[]> => {
  // const productService = inject(ProductService);

  try {
    // const response = await firstValueFrom(productService.getTopMarcas());
    return preloadedProductsTopBrands;
    // return response;
  } catch (error) {
    // Fallback a datos mock en caso de error
    return [];
  }
};
